<template>
    <div id="navbar">
        <navbar-top></navbar-top>
        <navbar-bottom v-if="!storeMode || isDiamondsPage"></navbar-bottom>
        <navbar-mobile></navbar-mobile>
    </div>
</template>

<script>
  import NavbarTop from './Top.vue';
  import NavbarBottom from './Bottom.vue';
  import NavbarMobile from './Mobile.vue';
import { mapState } from 'vuex';

  export default {
    name: 'navbar',
    components: {
      'navbar-top': NavbarTop,
      'navbar-bottom': NavbarBottom,
      'navbar-mobile': NavbarMobile,
    },
  computed: {
        ...mapState('willyou', [
          'storeMode',
          'isDiamondsPage',
        ]),
    }
  }
</script>